// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guest-edit__phone[data-v-5f977f3e]{width:100%}.guest-edit__phone.desktop[data-v-5f977f3e]{display:block !important}.guest-edit__phone[data-v-5f977f3e] fieldset{width:100%}.guest-edit__phone[data-v-5f977f3e] a{height:2.9rem;margin-right:0px !important;padding-top:.68rem !important}.guest-edit__save-button[data-v-5f977f3e]{width:100px}", ""]);
// Exports
module.exports = exports;
